import { primaryColorByPartner } from 'helpers/getColorPartner';

export default {
  toolbar: {
    backgroundColor: primaryColorByPartner
  }
};
